import camelcase from "lodash.camelcase";

// Utility method for producing a "fullClass"-like string from a key/value pair
export default function formatClassName(key, value) {
    // Concatenate, camelCase, and remove all non-word characters (anything not in [a-zA-Z0-9_]).
    return camelcase(`${key}${value}`).replace(/\W/gi, "");
}
